import React, { Component } from "react";

import {
  CCol,
  CRow,
  CCollapse,
  CModal,
  CModalHeader,
  CModalTitle,
  CLink
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import EvaluationStatistics from "./evaluationStatistics";
import Statistics from "./statistics";
import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ImgNoData from "../../../../assets/imgs/graduation.svg";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../../components/Breadcrumb";
import Cards from "../../../../components/Cards/Cards";
import TextCreator from "../../../../components/Content/TextCreator";
import CorrectLiterarte from "../../../../components/CorrectLiterarte";
import Interface from "../../../../components/Interface";
import LiterarteModal from "../../../../components/LiterarteModal";
import Loading from "../../../../components/Loading";
import ModalTools from "../../../../components/ModalTools";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import ShareModal from "../../../../components/ShareModal";
import Students from "../../../../components/Students/Students";
import UploadModal from "../../../../components/UploadModal";
import Widgets from "../../../../components/Widgets/Widgets";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { baseDate } from "../../../../utils/date";
// import Literarte from '../../../../components/SlateComponents/Literarte';

import "../../../../scss/style2.scss";

const FileDownload = require("js-file-download");

class TrailActivity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // endpoint: URL.node,
      // response: false,
      studentsList: [],
      // user: {},
      activity: null,
      // room_id: null,
      activity_id: this.props.match.params.id,
      allocation_id: this.props.match.params.allocation_id,
      activity_name: "",
      // message: "",
      loading: true,
      iframe: false,
      // questions: [],
      leftCollapse: true,
      rightCollapse: true,
      listQuestion: {
        id: "",
        show: false,
        average: 0
      },
      textProduction: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      correctLiterarte: {
        id: "",
        show: false
      },
      // ability_list: [],
      contentId: "",
      contentName: "",
      totalActivityItems: 0,
      uploadModal: false,
      modalTool: false,
      toolName: null,
      toolId: null,
      evaluationStatisticsModal: false,
      statisticsModal: false,
      shareModal: false,
      item_id: null,
      literarteStart: null,
      roomId: null,
      url: null,
      start: null,
      end: null
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  createExecution(callback = () => null) {
    const obj = {
      activity_id: this.state.activity_id
    };

    axios
      .post(`${URL.api}activity/execution/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ execution_id: resp.data.data }, () => callback());
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      });
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleActivity(() => this.initializeActivity());
  }

  handleActivity(callback = () => null) {
    if ([7, 8, 9].includes(this.props.general.active_roles.role_id)) {
      this.createExecution(() => {
        axios
          .get(
            `${URL.api}activity/activity/singleViewByExecution/${this.state.execution_id}`,
            {
              headers: {
                authorization: `Bearer ${this.props.user.token}`,
                "Access-Control-Allow-Origin": "*"
              }
            }
          )
          .then(resp => {
            if (resp.data.success) {
              const activity = {
                ...resp.data.data,
                items: resp.data.data.items.map(item => ({
                  ...item,
                  title: item.name,
                  subtitle: item.type_name
                }))
              };

              this.setState(
                {
                  activity,
                  itens: activity.items
                },
                () => {
                  callback();
                }
              );
            } else {
              this.error("Falha ao encontrar a atividade!");
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              this.error("Sua sessão expirou!");
              this.props.logout();
            } else {
              this.error("Falha ao encontrar a atividade!");
            }
          });
      });
    } else {
      axios
        .get(
          `${URL.api}activity/activity/singleView/${this.state.activity_id}`,
          {
            headers: {
              authorization: `Bearer ${this.props.user.token}`,
              "Access-Control-Allow-Origin": "*"
            }
          }
        )
        .then(resp => {
          if (resp.data.success) {
            const activity = {
              ...resp.data.data,
              items: resp.data.data.items.map(item => ({
                ...item,
                title: item.name,
                subtitle: item.type_name
              }))
            };

            this.setState(
              {
                activity,
                itens: activity.items
              },
              () => {
                callback();
              }
            );
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.error("Sua sessão expirou!");
            this.props.logout();
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        });
    }
  }

  initializeActivity() {
    const user = {
      id: this.props.user.user.id,
      name: this.props.user.user.username
    };

    axios
      .get(
        `${URL.api}activity/trail_allocation/singleView/${this.state.allocation_id}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          if (resp.data.success) {
            const trailActivity = resp.data.data.trail?.trail_activities?.find(
              trailActivity =>
                trailActivity.activity_id ===
                parseInt(this.props.match.params.id)
            );

            const executions = trailActivity?.activity?.executions || [];

            const studentsList = (
              resp.data.data.users?.length > 0
                ? resp.data.data.users
                : resp.data.data.room?.users?.filter(
                    item => !item.administrator
                  ) || []
            ).map(item => ({
              id: item.user?.id,
              name: item.user?.name,
              online: "desconectado",
              color: "primary",
              activity: "",
              profileImage:
                URL.img +
                (item.user?.photo || "uploads/users/profileEmpty.jpg"),
              role_id: 7,
              execution_items:
                executions
                  .find(execution => execution.user_id === item.user?.id)
                  ?.items?.map(executionItem => ({
                    ...executionItem,
                    user_id: item.user?.id
                  })) || [],
              items: this.state.itens.length
            }));

            const listQuestion = {
              id: "",
              show: false,
              average: 0
            };

            const activity = {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.activity,
              // eslint-disable-next-line react/no-access-state-in-setstate
              items: this.state.activity.items.map(item => ({
                ...item,
                title: item.name,
                subtitle: item.type_name
              }))
            };

            this.setState({
              loading: false,
              activity,
              activity_id: activity.id,
              // response: true,
              activity_name: activity.name,
              activity_description_box: {
                type: 0,
                text: activity.description
              },
              listQuestion,
              totalActivityItems: activity.items.length,
              studentsList,
              // user,
              itens: activity.items,
              roomId: resp.data.data.room_id,
              start: trailActivity.start,
              end: trailActivity.end
            });
          } else {
            this.error("Não foi possível obter informações sobre a atividade");
          }
        },
        error => {
          this.error("Não foi possível obter informações sobre a atividade");
        }
      );
  }

  closeLeft() {
    document.getElementById("leftSide").style.display = "none";
    document.getElementById("closeLeft").style.display = "none";
    document.getElementById("openLeft").style.display = "block";
  }

  openLeft() {
    document.getElementById("leftSide").style.display = "block";
    document.getElementById("closeLeft").style.display = "block";
    document.getElementById("openLeft").style.display = "none";
  }

  closeRight() {
    document.getElementById("rightSide").style.display = "none";
    document.getElementById("closeRight").style.display = "none";
    document.getElementById("openRight").style.display = "block";
  }

  openRight() {
    document.getElementById("rightSide").style.display = "block";
    document.getElementById("closeRight").style.display = "block";
    document.getElementById("openRight").style.display = "none";
  }

  createItemExecution(item, finished, callback = () => null) {
    const late = this.state.end && Date.parse(this.state.end) < Date.now();

    if (finished || late) {
      callback();
      return;
    }

    const obj = {
      execution_id: this.state.execution_id,
      item_id: item,
      completion_percentage: 100,
      start: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString(),
      end: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString()
    };

    axios
      .post(`${URL.api}activity/execution/item/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          callback();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      });
  }

  openItem = item => {
    const late = this.state.end && Date.parse(this.state.end) < Date.now();

    const tryCreateItemExecution = () => {
      if (
        item.id &&
        [7, 8, 9].includes(this.props.general.active_roles.role_id)
      ) {
        this.createItemExecution(item.id, item.item_percentage === 100, () =>
          this.handleActivity()
        );
      }
    };

    if (item.type_id === 12) {
      this.setState({
        listQuestion: {
          id: item.obj_id,
          show: true
        },
        contentId: item.obj_id,
        contentName: item.title,
        item_id: item.id
      });
    } else if (item.type_id === 33) {
      this.setState({ lo_id: item.obj_id, textModal: true });
    } else if (item.type_id === 15) {
      // NEWTON
      this.setState({
        modalTool: true,
        toolId: item.type_id,
        toolName: item.title,
        item_id: item.id
      });

      tryCreateItemExecution();
    } else if (item.type_id === 16 || item.type_id === 27) {
      // LINK
      axios
        .get(`${URL.api}content/los/singleView/${item.obj_id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            window.open(resp.data.data.path, "_blank");

            tryCreateItemExecution();
          },
          () => {
            toastr.error(
              "Falha",
              "Não foi possível abrir o link. Tente novamente!"
            );
          }
        );
    } else if (item.type_id === 14) {
      // LITERARTE
      if (late && item.item_percentage !== 100) {
        toastr.warning("Atenção", "A atividade já foi encerrada!");
        return;
      }

      this.setState({
        textProduction: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          ...this.state.textProduction,
          show: true,
          id: item.obj_id
        },
        item_id: item.id,
        contentName: item.title,
        literarteStart: new Date()
      });
    } else if (item.type_id === 18) {
      // Upload

      if (item.item_percentage === 100) {
        toastr.info(
          "Item realizado",
          item.item_grade
            ? `Você tirou a nota ${item.item_grade}`
            : "A correção ainda não está disponível"
        );
      } else {
        this.setState({
          uploadModal: true,
          contentId: item.obj_id,
          contentName: item.title,
          item_id: item.id
        });
      }
    } else if (item.type_id !== 17) {
      // Conteúdos da interface
      this.setState({
        iframe: true,
        contentId: item.obj_id,
        contentName: item.title,
        item_id: item.id
      });
    } else {
      // Download
      if (item.link?.endsWith(".pdf")) {
        this.setState({
          iframe: true,
          contentId: null,
          contentName: item.title,
          item_id: item.id,
          url: item.link
        });

        tryCreateItemExecution();
        return;
      }

      const downloadPath = item.link
        ? item.link.substring(item.link.indexOf("uploads/") + 8)
        : `${item.obj_id === 1 ? "activity" : "repo"}/${item.name}`;

      axios
        .get(`${URL.api}download/${downloadPath}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, item.name);

          tryCreateItemExecution();
        });
    }
  };

  saveTextProduction = pages => {
    let pagesObj = [];
    for (let i = 0; i < pages.length; i++) {
      pagesObj.push({
        number: i,
        content: JSON.stringify(pages[i])
      });
    }

    let obj = {
      user_id: this.props.user.user.id,
      literarte_activity_id: this.state.textProduction.id,
      pages: pagesObj,
      item_id: this.state.item_id,
      execution_id: this.state.execution_id,
      start: baseDate(this.state.literarteStart),
      end: baseDate(new Date())
    };

    axios
      .post(`${URL.api}literarte/production_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          toastr.success("Sucesso", "O texto foi salvo.");
          this.setState({
            textProduction: {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.textProduction,
              show: false
            }
          });
        }
      });
  };

  render() {
    const late =
      !this.state.loading &&
      this.state.end &&
      Date.parse(this.state.end) < Date.now();

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            { path: "/classroom/me", to: "/classroom/me" },
            {
              path: "/classroom/:id/trails",
              to: `/classroom/${this.state.roomId}/trails`
            },
            {
              path: "/trail/do/:allocation_id",
              to: `/trail/do/${this.props.match.params.allocation_id}`
            }
          ]}
        />
        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            title={this.state.contentName}
            onClose={() =>
              this.setState({ iframe: false }, () => this.handleActivity())
            }
            aula={this.state.contentId}
            atividade={this.state.activity_id}
            act_item_id={this.state.item_id}
            act_execution_id={late ? undefined : this.state.execution_id}
            currentRoute={this.props.currentRoute}
            url={!this.state.contentId && this.state.url}
          />
        )}
        <ModalTools
          show={this.state.modalTool}
          tool={this.state.toolId}
          title={this.state.toolName}
          onClose={() =>
            this.setState({ modalTool: false }, () => this.handleActivity())
          }
          activity={this.state.activity_id}
          students={this.state.studentsList}
          currentRoute={this.props.currentRoute}
        />
        <EvaluationStatistics
          show={this.state.evaluationStatisticsModal}
          onClose={() => this.setState({ evaluationStatisticsModal: false })}
          allocation_id={this.state.allocation_id}
          activity={this.state.activity_id}
          currentRoute={this.props.currentRoute}
        />
        <Statistics
          show={this.state.statisticsModal}
          onClose={() => this.setState({ statisticsModal: false })}
          allocation_id={this.state.allocation_id}
          activity={this.state.activity_id}
          currentRoute={this.props.currentRoute}
        />
        <ShareModal
          show={this.state.shareModal}
          onClose={() => this.setState({ shareModal: false })}
          link={window.location.href}
        />
        {this.state.uploadModal && (
          <UploadModal
            onClose={() =>
              this.setState({ uploadModal: false }, () => this.handleActivity())
            }
            upload_id={this.state.contentId}
            activity_id={this.state.activity_id}
            item_id={this.state.item_id}
            execution_id={this.state.execution_id}
          />
        )}
        {this.state.textProduction.id !== "" ? (
          <LiterarteModal
            id={this.state.textProduction.id}
            user_id={this.props.user.user.id}
            show={this.state.textProduction.show}
            onClose={() =>
              this.setState(
                {
                  textProduction: {
                    // eslint-disable-next-line react/no-access-state-in-setstate
                    ...this.state.textProduction,
                    show: false
                  }
                },
                () => this.handleActivity()
              )
            }
            title={this.state.contentName}
            value={this.state.textProduction.value}
            onChange={value =>
              this.setState({
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  value
                }
              })
            }
            saveTextProduction={pages => this.saveTextProduction(pages)}
          />
        ) : null}
        {this.state.correctLiterarte && (
          <CorrectLiterarte
            id={this.state.correctLiterarte.id}
            show={this.state.correctLiterarte.show}
            onClose={() =>
              this.setState({
                correctLiterarte: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.correctLiterarte,
                  show: false
                }
              })
            }
            user_id={this.props.user.user.id}
          />
        )}
        <CModal
          show={this.state.listQuestion.show}
          onClose={() =>
            this.setState(
              {
                listQuestion: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  id: this.state.listQuestion.id,
                  show: false
                }
              },
              () => this.handleActivity()
            )
          }
          size="lg w-100 h-100 m-0 p-2 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop={false}
        >
          <CModalHeader closeButton>
            <CModalTitle>{this.state.contentName}</CModalTitle>
          </CModalHeader>
          {this.state.listQuestion.show && (
            <ApplicatedQuestionList
              activityId={this.state.activity_id}
              currentRoute={this.props.currentRoute}
              allocation_id={null}
              id={this.state.listQuestion.id}
              history={this.props.history}
              prototype={false}
              item_id={this.state.item_id}
              execution_id={this.state.execution_id}
              result_type={this.state.activity.result_type}
              ended={late}
              close={() =>
                this.setState(
                  {
                    listQuestion: {
                      // eslint-disable-next-line react/no-access-state-in-setstate
                      id: this.state.listQuestion.id,
                      show: false
                    }
                  },
                  () => this.handleActivity()
                )
              }
            />
          )}
        </CModal>
        {this.state.textModal && (
          <TextCreator
            show={this.state.textModal}
            onClose={() =>
              this.setState({
                textModal: false
                // currentLOLink: null
              })
            }
            // eslint-disable-next-line react/jsx-boolean-value
            showOnly={true}
            currentLOLink={this.state.lo_id}
          />
        )}
        {!this.state.loading ? (
          <>
            <CRow>
              <CCol lg="12">
                <Cards
                  header={
                    <>
                      <CLink
                        className="card-header-action mr-3 p-0"
                        onClick={() =>
                          this.props.history.push(
                            `/trail/do/${this.props.match.params.allocation_id}`
                          )
                        }
                      >
                        <i className="fa fa-chevron-left"></i>
                      </CLink>
                      {this.state.activity_name}
                    </>
                  }
                  body={this.state.activity_description_box}
                  icon={
                    ![7, 8, 9].includes(this.props.general.active_roles.role_id)
                      ? "share-alt"
                      : null
                  }
                  onIconClick={
                    ![7, 8, 9].includes(this.props.general.active_roles.role_id)
                      ? () => this.setState({ shareModal: true })
                      : null
                  }
                  secondaryIcon={
                    ![7, 8, 9].includes(this.props.general.active_roles.role_id)
                      ? "rotate-left"
                      : null
                  }
                  onSecondaryIconClick={
                    ![7, 8, 9].includes(this.props.general.active_roles.role_id)
                      ? () =>
                          this.handleActivity(() => this.initializeActivity())
                      : null
                  }
                />
              </CCol>
            </CRow>
            {![7, 8, 9].includes(this.props.general.active_roles.role_id) ? (
              <React.Fragment>
                <CRow className="flex-1">
                  <CCol xs="12" md="6">
                    <div className="pt-3 d-flex align-items-center justify-content-between">
                      <h4 className="m-0">Itens</h4>
                      <i
                        onClick={() =>
                          this.setState(state => ({
                            leftCollapse: !state.leftCollapse
                          }))
                        }
                        className={`text-muted activity-collapse fa fa-chevron-${
                          this.state.leftCollapse ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <hr
                      style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }}
                    />
                    <CCollapse show={this.state.leftCollapse}>
                      <Widgets
                        itens={this.state.itens}
                        openItem={this.openItem}
                        closeItem={this.closeItem}
                        teacher
                        onEvaluationStatistics={id =>
                          this.setState({ evaluationStatisticsModal: false })
                        }
                      />
                    </CCollapse>
                  </CCol>
                  <CCol xs="12" md="6">
                    <div className="pt-3 d-flex align-items-center justify-content-between">
                      <h4 className="m-0">Usuários</h4>
                      <i
                        onClick={() =>
                          this.setState(state => ({
                            rightCollapse: !state.rightCollapse
                          }))
                        }
                        className={`text-muted activity-collapse fa fa-chevron-${
                          this.state.rightCollapse ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    <hr
                      style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }}
                    />
                    <CCollapse show={this.state.rightCollapse}>
                      <Students
                        studentsList={this.state.studentsList}
                        listQuestion={this.state.listQuestion}
                        totalActivityItems={this.state.totalActivityItems}
                        activityItems={this.state.itens}
                        isTrailActivity
                      />
                    </CCollapse>
                  </CCol>
                </CRow>
              </React.Fragment>
            ) : (
              <>
                {this.state.start && new Date(this.state.start) > new Date() ? (
                  <CRow className="flex-1">
                    <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                      <img
                        src={ImgNoData}
                        style={{ height: "240px", marginBottom: "2rem" }}
                        alt=""
                      />
                      <p
                        style={{ fontSize: "1.5rem" }}
                        className="mb-2 font-weight-bold text-center"
                      >
                        A atividade ainda não foi liberada
                      </p>
                      <span className="text-muted text-center">
                        Tente voltar daqui a alguns minutos
                      </span>
                    </div>
                  </CRow>
                ) : (
                  <CRow className="flex-1">
                    {this.state.itens.length > 0 ? (
                      <CCol lg="12">
                        <div id="leftSide">
                          <Widgets
                            itens={this.state.itens}
                            openItem={this.openItem}
                            completionMark
                          />
                        </div>
                      </CCol>
                    ) : (
                      <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                        <img
                          src={ImgNoData}
                          style={{ height: "240px", marginBottom: "2rem" }}
                          alt=""
                        />
                        <p
                          style={{ fontSize: "1.5rem" }}
                          className="mb-2 font-weight-bold text-center"
                        >
                          Nenhum conteúdo foi liberado
                        </p>
                        <span className="text-muted text-center">
                          Entre em contato com seu professor
                        </span>
                      </div>
                    )}
                  </CRow>
                )}
              </>
            )}
          </>
        ) : (
          <Loading top="45" left="50" />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

TrailActivity.defaultProps = {
  hideLayout: false,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TrailActivity);
